<div
  class="modal fade show d-block"
  tabindex="-1"
  [ngStyle]="{ display: show ? 'block' : 'none' }"
  role="dialog"
  *ngIf="show"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
        <button type="button" class="btn-close" (click)="cancel()"></button>
      </div>
      <div class="modal-body">
        <p>{{ message }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" (click)="cancel()">
          {{ cancelText }}
        </button>
        <button type="button" class="btn btn-black" (click)="confirm()">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</div>
